export const clickOutsideMixin = {
  data: () => ({
    isFocused: false,
    outsideListenerAttached: false,
  }),
  watch: {
    isFocused(value) {
      if (value) this.attachOutsideListener();
      else this.detachOutsideListener();
    },
  },
  beforeDestroy() {
    this.detachOutsideListener();
  },
  methods: {
    attachOutsideListener() {
      if (this.outsideListenerAttached) return;
      document.addEventListener('click', this.handleOutsideClick);
      this.outsideListenerAttached = true;
    },
    detachOutsideListener() {
      if (!this.outsideListenerAttached) return;
      document.removeEventListener('click', this.handleOutsideClick);
      this.outsideListenerAttached = false;
    },
    handleOutsideClick(event) {
      const { root } = this.$refs;
      if (root && !root.contains(event.target)) {
        this.isFocused = false;
        this.$emit('blur');
      }
    },
  },
};
